import React, { useCallback, useRef, useState } from 'react'
import { CopyIconBlue } from "assests/GmsIcons";
import { debounce } from 'lodash';
import { updateAppletPlacementNote } from '../ARSServices/ARSServices';
import { toast } from 'react-toastify';
import OverlayIcon from 'Components/GMS/Rules/Components/OverlayIcon';

type AppletCardProps = {
    applet: AppletResponse;
    setAppletData: React.Dispatch<React.SetStateAction<AppletResponse[] | null>>
}
const AppletCard = ({ applet, setAppletData }: AppletCardProps) => {

    const [note, setNote] = useState<string>(applet.placement_note);
    const noteInputRef = useRef<HTMLInputElement>(null);

    const debouncedSave = useCallback(
        debounce(async (value: string) => {
            if (value === applet.placement_note) return;
            const res = await updateAppletPlacementNote(applet?.applet, applet?.channel_id, value);
            if (res?.done) {
                setAppletData(prev => {
                    if (!prev) return prev;

                    return prev.map(item =>
                        item.applet_id === applet?.applet_id
                            ? { ...item, placement_note: value }
                            : item
                    );
                });
            }
        }, 1000),
        [applet.applet, applet.channel_id, applet.applet_id, applet.placement_note, setAppletData]
    );

    const handleClipbord = () => {
        navigator.clipboard.writeText(applet?.applet).then(() => toast.success("Copied applet key"));
    }

    return (
        <div className=" tw-rounded-md tw-border tw-border-zinc-300 tw-bg-white tw-p-4 tw-mb-2">
            <div className="tw-flex tw-items-center tw-justify-between">
                <div className="tw-flex tw-items-center">
                    <span className="tw-text-gray-700 tw-font-medium tw-pr-1">Key</span>
                    <OverlayIcon
                        placement="right"
                        message={<p>{"Copy this key and add it to your ecommerce backend to display this Applet in the desired location on your website."}</p>}
                    />
                </div>

                {applet?.ab_testing_enabled && (
                    <div data-property-1="Active" className="tw-px-3.5 tw-py-1 tw-bg-orange-100 tw-rounded tw-inline-flex tw-justify-center tw-items-center tw-gap-2.5">
                        <div className="tw-text-center tw-justify-start tw-text-amber-600 tw-text-xs tw-font-medium">AB Testing - In Progress</div>
                    </div>
                )}
            </div>

            <div className="tw-mt-2 tw-flex tw-items-center tw-justify-between tw-bg-white">
                <div className="tw-flex-1 tw-px-2.5 tw-py-2  tw-outline tw-outline-1 tw-outline-offset-[-1px] tw-outline-gray-200 tw-inline-flex tw-items-center tw-gap-2.5 tw-border tw-border-zinc-300  tw-bg-gray-100 tw-self-stretch tw-rounded-md tw-justify-start tw-text-blue-950 tw-text-sm tw-font-medium">{applet.applet}</div>
                <button className="tw-ml-2" onClick={handleClipbord}>
                    <CopyIconBlue />
                </button>
            </div>

            <div className="tw-mt-4">
                <label className="tw-block tw-text-sm tw-font-medium tw-text-gray-700">
                    Placement note
                </label>
                <div className="tw-mt-1">
                    <input
                        ref={noteInputRef}
                        type="text"
                        className="tw-w-full tw-h-16 tw-px-2.5 tw-py-2 tw-bg-white tw-outline tw-outline-1 tw-outline-offset-[-1px] tw-outline-gray-200 tw-inline-flex tw-justify-start tw-items-start tw-gap-2.5 tw-rounded-md tw-border tw-border-gray-300 tw-p-2 tw-text-gray-500"
                        placeholder="Enter note"
                        value={note}
                        onChange={(e) => {
                            setNote(e.target.value);
                            debouncedSave(e.target.value);
                        }}
                    />
                </div>
            </div>

            <div className="tw-mt-4">
                <label className="tw-block tw-text-sm tw-font-medium tw-text-gray-700">
                    Model
                </label>
                <div className="tw-mt-1 tw-flex tw-flex-wrap tw-gap-2">
                    {applet.model && applet.model.length > 0 ? (
                        applet.model.map((model, index) => (
                            <span
                                key={index}
                                className="tw-rounded-md tw-bg-gray-100 tw-px-3 tw-py-1 tw-text-sm tw-text-gray-800"
                            >
                                {model.name}
                            </span>
                        ))
                    ) : (
                        <span className="tw-text-gray-500">No model available</span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AppletCard